import Vue from 'vue';
import App from './App';
import plugins from '@/plugins/index.js';
import store from '@/store/store';
Vue.prototype.$store = store;
plugins(Vue, App);



// WEBPACK FOOTER //
// ./src/pages/yscy/index/index.js